import { hideLoading, showLoading } from 'react-redux-loading-bar';
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../../../store/root-reducer';
import ModifyInboxRadarSubscription from './modify-inbox-radar-subscription';
import {
  getConnectedUsersAndEmailAccountsRequest,
  applyCouponCodeRequest,
  upgradePlanRequest,
  downgradePlanRequest,
  upgradeLtdPlanRequest,
  modifyLtdPlanRequest,
  getInboxAnalyzerPlansRequest,
  getInboxAnalyzerSubscriptionRequest,
  purchaseInboxAnalyzerSubscriptionRequest,
  purchaseInboxAnalyzerModifySubscriptionRequest,
  modifyInboxAnalyzerSubscriptionRequest,
  calculateInboxAnalyzerPayRequest,
} from '../../extra-actions';
import {
  PurchaseSubscriptionRequest,
  ApplyCouponCodeRequest,
  ModifySubscriptionRequest,
  PurchaseModifySubscriptionRequest,
  CalculatePayRequest,
  UpgradePlanRequest,
  DowngradePlanRequest,
  LTDUpgradePayload,
  LTDModifyPayload,
} from '../../types';
import {
  deleteAppliedCouponCode,
  resetCalculateInboxAnalyzerPayState,
  resetConnectedUsersAndEmailAccountsRequest,
  resetInboxAnalyzerModifySubscriptionResponse,
  resetPurchaseModifySubscriptionResponse,
  selectPlan,
} from '../../billing-subscription-slice';

const mapStateToProps = (state: RootState) => ({
  sendGetInboxAnalyzerSubscriptionRequestStatus:
    state.billingAndSubscription.getInboxAnalyzerSubscriptionRequest.status,
  sendGetInboxAnalyzerSubscriptionRequestError:
    state.billingAndSubscription.getInboxAnalyzerSubscriptionRequest.error,
  sendGetInboxAnalyzerPlansRequestStatus:
    state.billingAndSubscription.getInboxAnalyzerPlansRequest.status,
  sendGetInboxAnalyzerPlansRequestError:
    state.billingAndSubscription.getInboxAnalyzerPlansRequest.error,
  sendPurchaseInboxAnalyzerSubscriptionRequestStatus:
    state.billingAndSubscription.purchaseInboxAnalyzerSubscriptionRequest
      .status,
  sendGetInboxAnalyzerSubscriptionResponse:
    state.billingAndSubscription.getInboxAnalyzerSubscriptionResponse,
  sendGetConnectedUsersAndEmailAccountsRequestStatus:
    state.billingAndSubscription.getConnectedUsersAndEmailAccountsRequest
      .status,
  sendGetConnectedUsersAndEmailAccountsRequestError:
    state.billingAndSubscription.getConnectedUsersAndEmailAccountsRequest.error,
  sendGetConnectedUsersAndEmailAccountsRequestResponse:
    state.billingAndSubscription.getConnectedUsersAndEmailAccountsResponse,
  sendApplyCouponCodeRequestStatus:
    state.billingAndSubscription.applyCouponCodeRequest.status,
  sendApplyCouponCodeRequestMessage:
    state.billingAndSubscription.applyCouponCodeRequest.message,
  sendApplyCouponCodeRequestError:
    state.billingAndSubscription.applyCouponCodeRequest.error,
  getCouponCodeResponse: state.billingAndSubscription.applyCouponCodeResponse,
  sendGetInboxAnalyzerModifySubscriptionRequestStatus:
    state.billingAndSubscription.calculateInboxAnalyzerPayRequest.status,
  sendGetPurchaseInboxAnalyzerModifySubscriptionRequestStatus:
    state.billingAndSubscription.purchaseInboxAnalyzerModifySubscriptionRequest
      .status,
  sendGetModifySubscriptionResponse:
    state.billingAndSubscription.modifySubscriptionResponse,
  sendGetInboxAnalyzerCalculatePayResponse:
    state.billingAndSubscription.getCalculateInboxAnalyzerPayResponse,
  selectedPlanDetails: state.billingAndSubscription.selectedPlanDetails,

  upgradeLtdPlanRequestStatus:
    state.billingAndSubscription.upgradeLtdPlanRequest.status,
  upgradeLtdPlanRequestError:
    state.billingAndSubscription.upgradeLtdPlanRequest.error,
  modifyLtdPlanRequestStatus:
    state.billingAndSubscription.modifyLtdPlanRequest.status,
  modifyLtdPlanRequestError:
    state.billingAndSubscription.modifyLtdPlanRequest.error,

  userCurrentPlan: state.home.subscription?.planCode,
  subscriptionPlanStatus: state.home.subscription?.status,

  sendGetInboxAnalyzerPlansResponse:
    state?.billingAndSubscription?.getInboxAnalyzerPlansResponse,
});

const mapDispatchToProps = {
  sendGetInboxAnalyzerSubscriptionRequest: () =>
    getInboxAnalyzerSubscriptionRequest(),
  sendGetInboxAnalyzerPlansRequest: () => getInboxAnalyzerPlansRequest(),
  sendPurchaseInboxAnalyzerSubscriptionRequest: (
    payload: PurchaseSubscriptionRequest,
  ) => purchaseInboxAnalyzerSubscriptionRequest(payload),
  sendApplyCouponCodeRequest: (payload: ApplyCouponCodeRequest) =>
    applyCouponCodeRequest(payload),
  sendGetConnectedUsersAndEmailAccountsRequest: () =>
    getConnectedUsersAndEmailAccountsRequest(),
  resetConnectedUsersAndEmailAccountsRequest: () =>
    resetConnectedUsersAndEmailAccountsRequest(),
  deleteAppliedCouponCode: () => deleteAppliedCouponCode(),
  sendModifyInboxAnalyzerSubscriptionRequest: (
    payload: ModifySubscriptionRequest,
  ) => modifyInboxAnalyzerSubscriptionRequest(payload),
  sendPurchaseInboxAnalyzerModifySubscriptionRequest: (
    payload: PurchaseModifySubscriptionRequest,
  ) => purchaseInboxAnalyzerModifySubscriptionRequest(payload),
  resetInboxAnalyzerModifySubscriptionResponse: () =>
    resetInboxAnalyzerModifySubscriptionResponse(),
  resetCalculateInboxAnalyzerPayState: () =>
    resetCalculateInboxAnalyzerPayState(),
  resetPurchaseModifySubscriptionResponse: () =>
    resetPurchaseModifySubscriptionResponse(),
  sendGetCalculateInboxAnalyzerPayRequest: (payload: CalculatePayRequest) =>
    calculateInboxAnalyzerPayRequest(payload),
  sendUpgradePlanRequest: (payload: UpgradePlanRequest) =>
    upgradePlanRequest(payload),
  sendDowngradePlanRequest: (payload: DowngradePlanRequest) =>
    downgradePlanRequest(payload),
  selectPlan: (payload) => selectPlan(payload),
  hideLoading: () => hideLoading(),
  showLoading: () => showLoading(),

  sendUpgradeLtdPlanRequest: (payload: LTDUpgradePayload) =>
    upgradeLtdPlanRequest(payload),

  sendModifyLtdPlanRequest: (payload: LTDModifyPayload) =>
    modifyLtdPlanRequest(payload),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector>;

export type LocationStateType = {
  isModifySubscription: boolean;
};

export default connector(ModifyInboxRadarSubscription);
